// What the organization's storage costs a month, by what each part is billed as: videos by the
// hour, their old versions at the current duration, the included encodes, audio and other files by
// the gigabyte, and the trash. Volumes for every member; the amounts, the two monthly rates and the
// five costliest assets for a billing manager — the amounts only on a platform that sells credits.

import { api } from '../client'
import type { components } from '../schema'

export type StorageCostView = components['schemas']['StorageCostView']
export type StorageCostCategory = components['schemas']['StorageCostCategory']
export type StorageCostKind = components['schemas']['StorageCostKind']
export type StorageCostAsset = components['schemas']['StorageCostAsset']
export type StorageRates = components['schemas']['StorageRates']

/** The storage split the way the meter bills it, priced where the caller may read the money. */
export function getStorageCosts(signal?: AbortSignal): Promise<StorageCostView> {
  return api.get<StorageCostView>('/orgs/current/storage-costs', undefined, signal)
}
